module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "ded"
  }, [_vm._v("I only wanted to be just a man fulfilled ")]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_vm._v("but a little more free")]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_vm._v("A little more free, a little more free.")]), _vm._v(" "), _c('p', {
    staticClass: "chicago"
  }, [_c('em', {
    staticClass: "itals"
  }, [_vm._v("Chicago, “Flight 602”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08d73325","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ALittleMoreFree_Text_Final-2.vue
// module id = 69
// module chunks = 0